import React from 'react';
import { Link } from 'gatsby';
import moment from 'moment';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import StaticPicture from '../StaticImage';

import {
  PostContainer,
  PostFigure,
  PostLink,
  Author,
  PostHeading,
} from './searchPost.styled';

const SearchPost = ({
  imgSrc,
  altText,
  postTitle,
  postAuthor,
  authorNames,
  postTime,
  slug,
  type,
  postsFields,
  optimizeImage,
  policyAuthors,
  displayAuthor,
}) => {
  const editedDate = moment(postTime).format('MMMM D, YYYY');
  return (
    <PostContainer data-testid='post-container'>
      <PostLink to={`/${type}/${slug}/`} data-testid='post-link'>
        <PostFigure data-testid='post-img'>
          {optimizeImage ? (
            <GatsbyImage image={getImage(optimizeImage)} alt={altText} />
          ) : (
            <StaticPicture imgFile={imgSrc} altText={altText} size='m' />
          )}
        </PostFigure>
      </PostLink>
      <PostHeading>
        <PostLink to={`/${type}/${slug}/`}>{postTitle}</PostLink>
      </PostHeading>
      {(postAuthor || authorNames) && editedDate && (
        <Author displayAuthor={displayAuthor} data-testid='authors-list'>
          {authorNames ? (
            authorNames.map((value, index) => (
              <span className='author-container' key={index}>
                <Link
                  to={`/author/${value.slug}/`}
                  className='author-name'
                  title={value.name}
                >
                  {value.name}
                </Link>
                <span>{index !== authorNames.length - 1 && ', '}</span>
              </span>
            ))
          ) : (
            <Link
              to={`/author/${postAuthor}/`}
              className='author-container'
              title={postAuthor}
            >
              <span className='name'>{postAuthor}</span>
            </Link>
          )}
          {((authorNames &&
            Array.isArray(authorNames) &&
            authorNames.length > 0) ||
            postAuthor) &&
            editedDate && <span className='divider' />}
          <span>{editedDate}</span>
        </Author>
      )}
      {policyAuthors && (
        <Author>
          {policyAuthors ? (
            policyAuthors.map((value, index) => (
              <span key={index}>
                <Link
                  to={`/author/${value.slug}/`}
                  className='author-name'
                  title={value.name}
                >
                  {value.name}
                </Link>
                <span>{index !== policyAuthors.length - 1 && ', '}</span>
              </span>
            ))
          ) : (
            <Link to={`/author/${postAuthor}/`} title={postAuthor}>
              <span className='name'>{postAuthor}</span>
            </Link>
          )}
          {((policyAuthors &&
            Array.isArray(policyAuthors) &&
            policyAuthors.length > 0) ||
            postAuthor) &&
            editedDate && <span className='divider' />}
          {editedDate && <span>{editedDate}</span>}
        </Author>
      )}
    </PostContainer>
  );
};

export default SearchPost;
